var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',{attrs:{"type":"date","align":"center","value-format":"yyyy-MM-dd"},model:{value:(_vm.temp),callback:function ($$v) {_vm.temp=$$v},expression:"temp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }